import { useParams } from "react-router-dom";

import i18n from "i18next";

import { useContentSelectors } from "../store/content/content.selectors";

import { useMatchRoute } from "./use-match-route";

export const useUpperSeo = () => {
  const tag = useMatchRoute()?.tag;
  const { lang } = useParams();
  const { content } = useContentSelectors();

  const language = lang || i18n.language;

  const upperSeo = {
    title: content?.[tag]?.[language]?.heading.title,
    description: content?.[tag]?.[language]?.heading.description,
  };

  const createDescMarkup = () => ({
    __html: upperSeo.description ? upperSeo.description : "",
  });

  return { title: upperSeo?.title ? upperSeo.title : null, createDescMarkup };
};
